<template>
  <div class="registerStepConBox">
    <div class="stepCon">
      <div class="chioseBackBox">
        <div class="headBox">
          <img
            class="promptIcon"
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260512134722386549.svg"
            alt=""
          />
        </div>
        <div class="chioseConBox">
          <div class="titleBox">
            <!-- 开启您的Rakumart之旅 -->
            <h2 class="chioseTitleH1">
              {{ $fanyi("开启您的Rakumart之旅") }}
            </h2>
            <div class="chioseTitleFont">
              {{ $fanyi("输入您的个人信息") }}
            </div>
          </div>

          <div class="inputList">
            <el-form
              ref="formRef"
              :model="ops.formregister"
              :rules="formRules"
              @validate="validateMethods"
            >
              <div class="formRow">
                <el-form-item
                  :label="$fanyi('名称')"
                  :rules="ops.inputRequireVer"
                  prop="user_name"
                  class="inputOpt userNameBox"
                >
                  <el-input
                    v-model="ops.formregister.user_name"
                    :placeholder="$fanyi('请输入名字')"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$fanyi('姓氏')"
                  :rules="ops.inputRequireVer"
                  prop="user_last_name"
                  class="inputOpt"
                >
                  <el-input
                    v-model="ops.formregister.user_last_name"
                    :placeholder="$fanyi('请输入姓氏')"
                  ></el-input>
                </el-form-item>
              </div>

              <div class="formRow">
                <el-form-item
                  :label="$fanyi('国家')"
                  :rules="ops.inputRequireVer"
                  prop="nation"
                  class="inputOpt"
                >
                  <el-input
                    v-model="ops.formregister.nation"
                    :placeholder="$fanyi('输入您的公司或企业所在的国家')"
                  ></el-input>
                  <div class="inputTipBox">
                    {{ $fanyi("*我们只从中国进口到意大利") }}
                  </div>
                </el-form-item>
              </div>

              <div class="formRow">
                <el-form-item
                  :label="$fanyi('省份')"
                  :rules="{
                    required: true,
                    message: $fanyi('此字段为必填项'),
                    trigger: 'blur',
                  }"
                  prop="country"
                  class="inputOpt"
                >
                  <el-select
                    filterable
                    name=""
                    clearable
                    @change="validateField('country')"
                    :placeholder="$fanyi('输入你的省份')"
                    v-model="ops.formregister.country"
                  >
                    <el-option
                      v-for="(ddd, index) in $imdata.provincesList"
                      :key="ddd + index"
                      :label="ddd"
                      :value="ddd"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>

              <div class="formRow">
                <el-form-item
                  :label="$fanyi('人口/城市')"
                  :rules="ops.inputRequireVer"
                  prop="city"
                  class="inputOpt"
                >
                  <el-input
                    v-model="ops.formregister.city"
                    :placeholder="$fanyi('输入您的人口/城市')"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="formRow">
                <el-form-item
                  :label="$fanyi('前缀')"
                  :rules="ops.inputRequireVer"
                  prop="country_phone"
                  class="inputOpt prefixBox"
                >
                  <el-select
                    class="phoneCountrySelect select"
                    :key="phoneKeyKey"
                    @change="
                      phoneKeyKey++; // 如果已经填写了手机号就验证一遍手机号
                      if (ops.formregister.mobile) {
                        validateField('mobile');
                        3;
                      }
                    "
                    filterable
                    v-model="ops.formregister.country_phone"
                  >
                    <el-option
                      v-for="(item, index) in $imdata.countryAndAreaCode"
                      :key="index"
                      :label="item.sxval"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  :label="$fanyi('电话')"
                  :rules="formRules.mobile"
                  prop="mobile"
                  class="inputOpt"
                >
                  <el-input
                    v-model="ops.formregister.mobile"
                    oninput="this.value=this.value.replace(/[^\d]/g,'')"
                    :placeholder="$fanyi('输入您的电话号码')"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <el-button
            type="primary"
            class="ContinuarBtn continueBtnSpacing"
            :class="{ isdisabled: btnDisable }"
            @click="!btnDisable ? next() : ''"
            >{{ $fanyi("继续") }}</el-button
          >
          <!-- 第三方谷歌登录入口 -->
          <div class="third-party-login">
            <div class="googlelogin" @click="gugedenglu">
              <img
                class="g-icon"
                :src="require('@/assets/login/google.svg')"
                alt=""
              />
              <!-- 使用google账号注册/登录 -->
              {{ $fanyi("使用google账号注册/登录") }}
            </div>
            <div id="googleBtnProviderRegister"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ops from "../utils/opStore.js";
import mradio from "./register-mradio.vue";
import mcheckBox from "./register-mcheckBox.vue";
import GWT from "jwt-decode";
import { GOOGLE_CLIENT_ID } from "@/config/googleOAuth";
export default {
  data() {
    // 字段校验
    var FieldCalibration = (rule, value, callback) => {
      this.$api
        .checkRegisterField({
          field: rule.field,
          value: value,
        })
        .then((res) => {
          //console.log("checkRegisterField", res);
          if (res.success == false) {
            // 接口 msg 含「格式不正确」展示格式错误，否则展示已被使用
            const errMsg =
              (res.msg || "").indexOf("格式不正确") !== -1
                ? this.$fanyi("格式不正确")
                : this.$fanyi("已被使用");
            callback(new Error(errMsg));
          } else {
            callback();
          }
        });
    };
    return {
      ops,
      smallStep: 1,
      phoneKeyKey: 23,
      formRules: {
        mobile: [
          {
            required: true,
            message: this.$fanyi("手机号为空"),
            trigger: "blur",
          },

          {
            validator: FieldCalibration,
            trigger: "blur",
          },
        ],
      },

      formRegisterStatus: { mobile: "" }, //选项是否正确输入
    };
  },
  components: {
    mcheckBox,
    mradio,
  },
  computed: {
    btnDisable() {
      let flog = false;
      Object.keys(this.formRegisterStatus).forEach((key) => {
        this.formRegisterStatus[key] == -1 ? (flog = true) : "";
      });
      return (
        !this.ops.formregister.user_name ||
        !this.ops.formregister.user_last_name ||
        !this.ops.formregister.nation ||
        !this.ops.formregister.country ||
        !this.ops.formregister.city ||
        !this.ops.formregister.country_phone ||
        !this.ops.formregister.mobile ||
        flog
      );
    },
  },
  created() {},
  mounted() {
    // 挂载谷歌登录按钮到隐藏容器，供自定义按钮触发
    this.initGoogleLogin();
  },
  methods: {
    // 初始化谷歌登录(GIS)
    initGoogleLogin() {
      const elId = "googleBtnProviderRegister";
      let tries = 0;
      const run = () => {
        const el = document.getElementById(elId);
        if (
          typeof window.google === "object" &&
          window.google.accounts &&
          window.google.accounts.id &&
          el
        ) {
          window.google.accounts.id.initialize({
            client_id: GOOGLE_CLIENT_ID,
            callback: this.handleCredentialResponse,
          });
          window.google.accounts.id.renderButton(el, {
            theme: "outline",
            size: "large",
          });
          window.google.accounts.id.prompt();
        } else if (tries < 30) {
          tries++;
          setTimeout(run, 300);
        }
      };
      run();
    },
    // 触发谷歌官方登录按钮
    gugedenglu() {
      this.$nextTick(() => {
        const btn = document.querySelector(
          "#googleBtnProviderRegister .nsm7Bb-HzV7m-LgbsSe-MJoBVe",
        );
        if (btn) {
          btn.click();
        } else {
          this.initGoogleLogin();
          setTimeout(() => {
            const retryBtn = document.querySelector(
              "#googleBtnProviderRegister .nsm7Bb-HzV7m-LgbsSe-MJoBVe",
            );
            if (retryBtn) retryBtn.click();
            else location.reload();
          }, 300);
        }
      });
    },
    // 谷歌登录回调：调用 userGoogleLogin 完成注册/登录，成功后跳转首页
    async handleCredentialResponse(response) {
      if (!response || !response.credential) return;
      const data = GWT(response.credential);
      const res = await this.$api.userGoogleLogin({
        google_token: data,
      });
      if (!res || !res.data) return;
      const googleLoginInfo = res.data;
      if (res.data.user_token) {
        localStorage.setItem("user_token", res.data.user_token);
        const infoRes = await this.$api.EuropegetUserInfo();
        if (infoRes) {
          this.$store.commit("userData", infoRes.data);
        }
        this.$store.dispatch("goodsToCartNum");
        // 注册页谷歌登录成功后统一跳转首页
        this.$fun.routerToPage("/");
        if (googleLoginInfo.password) {
          // 新用户：首页打开全局默认密码提示弹窗
          this.$nextTick(() => {
            this.$root.openGoogleInfoDialog?.(googleLoginInfo);
          });
        }
      }
    },
    validateMethods(prop, status) {
      // console.log(prop, status);
      this.$set(this.formRegisterStatus, prop, status ? 1 : -1);
      //console.log(this.formRegisterStatus[prop]);
    },
    goBack() {
      this.$router.go(-1);
    },
    next() {
      ops.goNext();
    },
    // 手动触发表单验证
    validateField(type) {
      if (this.ops.formregister[type])
        this.ops.formregister[type] = this.ops.formregister[type].trim();
      this.$refs.formRef.validateField(type, (v) => {});
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
@import "../css/registerCss.scss";
.registerStepConBox {
  width: 100%;
  @extend .dip;
  .stepCon {
  }
}
/* 继续按钮与下方谷歌按钮间距 16px */
.continueBtnSpacing {
  margin-bottom: 16px !important;
}
/* 第三方谷歌登录（MasterGo 269:18200） */
.third-party-login {
  width: 100%;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .googlelogin {
    width: 100%;
    height: 56px;
    padding: 18px 64px;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    box-sizing: border-box;
    // 品牌色/主色 #009246
    border: 1px solid #009246;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: #3d3d3d;
    cursor: pointer;
    .g-icon {
      display: block;
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }
    &:hover {
      background: #f9fafb;
    }
  }
  #googleBtnProviderRegister {
    width: 100%;
    display: none;
    justify-content: center;
    /deep/ iframe {
      margin: 0 auto;
    }
  }
}
</style>
